import type { ReactNode } from 'react'
import { SafeHtml } from '@shared/ui'
import { LearningTemplateResultBar } from './learning-template-result-bar'
import './learning-template-introduction.css'

export function LearningTemplateIntroduction({
  continuePending = false,
  continuePendingLabel,
  content,
  contentHtml,
  imageAlt = '',
  imageSrc,
  onContinue,
}: {
  readonly continuePending?: boolean
  readonly continuePendingLabel?: ReactNode
  readonly content?: ReactNode
  readonly contentHtml?: string | null
  readonly imageAlt?: string
  readonly imageSrc?: string
  readonly onContinue: () => void
}) {
  const introductionContent = content ?? (
    contentHtml ? (
      <SafeHtml className="learningTemplateIntroductionAuthoredHtml" html={contentHtml} />
    ) : null
  )

  return (
    <div className="learningTemplateIntroduction" data-qa="learning-template-introduction">
      <div className="learningTemplateIntroductionQuestion">
        {imageSrc ? (
          <div className="learningTemplateIntroductionIcon">
            <img alt={imageAlt} src={imageSrc} />
          </div>
        ) : null}
        {introductionContent ? (
          <div className="learningTemplateIntroductionContent">
            {introductionContent}
          </div>
        ) : null}
      </div>
      <LearningTemplateResultBar
        continuePending={continuePending}
        continuePendingLabel={continuePendingLabel}
        finished={false}
        onNext={onContinue}
      />
    </div>
  )
}
